import React from 'react';
import { useDropzone } from 'react-dropzone';
import Button from './Button';

const FileUploadForm = ({
  file,
  handleFileChange,
  handleSubmit,
  loading,
  error,
  email,
  handleEmailChange,
  emailError
}) => {
  // react-dropzone setup
  const onDrop = React.useCallback(
    (acceptedFiles) => {
      // Only accept the first file
      if (acceptedFiles && acceptedFiles.length > 0) {
        // Create a synthetic event to reuse your handleFileChange logic
        const syntheticEvent = {
          target: { files: acceptedFiles }
        };
        handleFileChange(syntheticEvent);
      }
    },
    [handleFileChange]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'] },
    multiple: false
  });

  return (
    <div className="max-w-md mx-auto mt-8" id="upload-section">
      <div className="glass rounded-lg shadow-xl p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-200">
              Upload Document
            </label>
            <div
              {...getRootProps()}
              className={`flex items-center justify-center w-full px-4 py-3 border-2 border-dashed rounded-md cursor-pointer transition-colors duration-200 ${
                isDragActive
                  ? 'border-indigo-500 bg-indigo-50'
                  : 'border-gray-800/50 bg-gray-900/60 hover:bg-gray-800/60'
              }`}
            >
              <input {...getInputProps()} />
              {file ? (
                <span>{file.name}</span>
              ) : isDragActive ? (
                <span>Drop the .docx file here ...</span>
              ) : (
                <span>Drag a file or click here to browse</span>
              )}
            </div>
            <p className="text-xs text-gray-400">
              Only .docx files are supported
            </p>
          </div>

          {/* Email Input Field */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-200">
              Email Address (optional)
            </label>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="your.email@example.com"
              className={`w-full px-4 py-2 bg-gray-900/60 border rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                emailError ? 'border-red-500' : 'border-gray-800/50'
              }`}
            />
            <p className="text-xs text-gray-400">
              We'll send you the cited document when processing is complete
            </p>
            {emailError && (
              <p className="text-xs text-red-400">{emailError}</p>
            )}
          </div>

          {file && (
            <Button
              type="submit"
              disabled={loading}
              variant="primary"
              className="w-full button-glow"
            >
              {loading ? 'Processing...' : 'Process Document'}
            </Button>
          )}

          {error && (
            <div className="p-3 text-sm text-red-300 bg-red-900/30 border border-red-800 rounded-md">
              {error}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default FileUploadForm;
